// extracted by mini-css-extract-plugin
module.exports = {"buttonsSection":"confirm_buttonsSection__3ZAZV"};